import React from "react";

/**
 * AboutMe — On-Screen "About" section, rendered inside Download.jsx.
 * Uses the shared dark theme tokens (--dl-*) defined in Download.css, so
 * styling lives in Download.css alongside every other section on the page.
 */
export default function AboutMe() {
  const facts = [
    "I've spent more than a decade building and supporting business software.",
    "Every line of code in On-Screen has been written by me.",
    "I release updates regularly based on user feedback.",
    "I'm from the Twin Cities, Minnesota.",
    "I still skateboard whenever I can.",
  ];

  return (
    <section className="about-me-modern" aria-labelledby="about-heading">
      <div className="dl-container">
        <div className="about-me-inner">
          <h2 id="about-heading" className="section-title-modern about-me-greeting">
            Hi, I'm Emeric.
          </h2>

          <div className="about-me-lede">
            <p>
              I built On-Screen because I believe small organizations deserve
              better tools — ones that actually work together instead of
              against each other.
            </p>
            <p>
              Whether it's a small business staying active on social media, a
              nonprofit organizing a fundraiser, or a school planning
              community events, I saw the same opportunity: bring everything
              into one place and make it simple.
            </p>
            <p className="about-me-emphasis">So I decided to build exactly that.</p>
          </div>

          <div className="about-me-body">
            <p>
              On-Screen is a product I designed, developed, and continue to
              improve every day. Every feature, every update, and every bug
              fix comes from real feedback and a desire to make running your
              organization a little easier.
            </p>
            <p>
              I've spent my career building and supporting enterprise
              software, but this project is different. This one is personal.
              I wanted to create software that feels approachable, reliable,
              and genuinely helpful — not bloated with features you'll never
              use.
            </p>
          </div>

          <div className="about-me-divider" role="presentation">
            <span className="about-me-divider-mark" />
          </div>

          <div className="about-me-skate">
            <p>
              When I'm not writing code, you'll usually find me skateboarding.
            </p>
            <p>
              Long before software, skateboarding taught me something that
              still shapes how I build products today: progress comes from
              showing up consistently, learning from failure, and improving a
              little every day. Those lessons are part of On-Screen just as
              much as the code itself.
            </p>
          </div>

          <p className="about-me-signoff">
            On-Screen is more than a project to me — it's a commitment. I
            built it to solve real problems, and I'm dedicated to making it
            better with every release. Every feature is created with one
            purpose: to give you a platform that's dependable, intuitive, and
            ready to grow alongside you. My goal isn't just to build great
            software — it's to earn your trust every time you use it.
          </p>
          <p className="about-me-name">— Emeric</p>

          <div className="about-me-facts">
            <h3 className="about-me-facts-heading">A few things about me</h3>
            <ul className="about-me-facts-list">
              {facts.map((fact, i) => (
                <li key={i} className="about-me-facts-item">
                  <span className="about-me-facts-bullet" aria-hidden="true" />
                  <span>{fact}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
